// Ícone SVG inline da bandeira Elo (sem requisição HTTP)
import * as React from 'react';

export function EloIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Elo" {...props}>
      <rect width="48" height="32" rx="4" fill="#000" />
      <circle cx="18" cy="16" r="6" fill="none" stroke="#FFF200" strokeWidth="2.4" />
      <circle cx="18" cy="16" r="2.4" fill="#EF4123" />
      <text
        x="28"
        y="20"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="700"
        fontSize="9"
        fill="#fff"
      >
        elo
      </text>
    </svg>
  );
}
